module.exports = __webpack_public_path__ + "fonts/Blinker-SemiBold.be8eec3.ttf";